import type { DocumentImageError, OnboardingSessionConfig } from '@onefootprint/request-types';
import type { DocumentRequirement, IdDocOutcome } from '@onefootprint/types';
import type { CommonIdvContext } from '../../utils/state-machine';

export type IdDocContext = {
  requirement: DocumentRequirement;
  config: OnboardingSessionConfig;
  sandboxOutcome?: IdDocOutcome;
};

export type IdDocProps = {
  context: IdDocContext;
  idvContext: CommonIdvContext;
  onDone: () => void;
};

export enum IdDocImageUploadError {
  unknownUploadError = 'unknown_upload_error',
  multipleFilesError = 'multiple_files_error',
  fileTypeNotAllowed = 'file_type_not_allowed',
  heicNotSupported = 'heic_not_supported',
  networkError = 'network_error',
}

export type DocumentImageErrorType = DocumentImageError | IdDocImageUploadError | 'custom_error';

export type IdDocImageErrorType = {
  errorType: DocumentImageErrorType;
  errorInfo?: string;
};

export type CaptureKind = 'auto' | 'manual' | 'upload';

type HeicToOptions = {
  blob: Blob;
  toType?: string | undefined;
  quality?: number | undefined;
};
export type HeicToModule = (mod: HeicToOptions) => Promise<Blob | Blob[]>;

export type ReceivedImagePayload = {
  captureKind: CaptureKind;
  extraCompressed: boolean;
  imageFile: File | Blob;
  forcedUpload: boolean;
  videoFile?: Blob;
};

export type CameraErrorCause =
  | 'unsupported-browser'
  | 'undefined-navigator'
  | 'not-found'
  | 'already-in-use'
  | 'constraint'
  | 'permission-denied'
  | 'other-error';
